
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ActionDefinition, ActionsApiUiClient, Duty, TriggerActionRequest } from '../../backend/backendapi';
import { handleError, initClient } from '../../../api';
import Spinner from '../../util/Spinner';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import CellStore from '../../../stores/CellStore';
import DutyStore from '../../../stores/DutyStore';

@Component({
  components: {
    Spinner,
    vSelect,
  },
})
export default class TriggerModalDutySpecific extends Vue {
  readonly cellStore = new CellStore();
  readonly dutyStore = new DutyStore();
  private readonly api = initClient(ActionsApiUiClient);

  triggering = false;

  definition: ActionDefinition | null = null;
  cellId: number | null = null;
  reference: string = '';

  get cellsForVSelect(): { id: number, name: string }[] {
    if (!this.duty?.cells?.length) {
      return this.cellStore.cellsForVSelect;
    }

    const cellIds = new Set(this.duty?.cells?.map(e => e.cellId) ?? []);
    return this.cellStore.cellsForVSelect.filter(cell => cellIds.has(cell.id));
  }

  get duty(): Duty | undefined {
    return this.dutyStore.duties.find(e => e.dutyId === this.dutyId);
  }

  get dutyId(): number | undefined {
    try {
      const config = JSON.parse(this.definition?.configurationJson ?? '{}') ?? {};
      return config.dutyId;
    } catch (e) {
      return;
    }
  }

  mounted(): void {
    this.cellStore.loadIfAbsent();
    this.dutyStore.loadIfAbsent();
  }

  public open(definition: ActionDefinition): void {
    this.definition = definition;
    this.cellId = null;
    this.reference = '';

    this.cellStore.reload();
    this.dutyStore.reload();

    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  async trigger(): Promise<void> {
    if (!this.definition) {
      return;
    }

    //prepare options
    let reference: string | null = this.reference.trim();
    reference = !!reference ? reference : null;
    const options = JSON.stringify({
      cellId: this.cellId,
      reference: reference,
    });

    //trigger
    this.triggering = true;
    try {
      await this.api.trigger(TriggerActionRequest.fromJS({ definitionId: this.definition.id, extraOptionsJson: options }));
      this.$toasted.info(this.$t('actions.triggerModal.actionTriggered').toString());
      this.dismiss();
    } catch (error) {
      handleError(this.$toasted, this.$i18n, error);
    } finally {
      this.triggering = false;
    }
  }
}
